function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from "react";
import PropTypes from "prop-types";
import NumericInput from "./numeric-input";

var Range = function Range(_ref) {
  var className = _ref.className,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? {} : _ref$value,
      maskType = _ref.maskType,
      integerLimit = _ref.integerLimit,
      _ref$minPlaceholder = _ref.minPlaceholder,
      minPlaceholder = _ref$minPlaceholder === void 0 ? "" : _ref$minPlaceholder,
      _ref$maxPlaceholder = _ref.maxPlaceholder,
      maxPlaceholder = _ref$maxPlaceholder === void 0 ? "" : _ref$maxPlaceholder,
      disabled = _ref.disabled,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
      onKeyPress = _ref.onKeyPress;

  var parseValidInt = function parseValidInt(val) {
    return !Number.isNaN(parseInt(val, 10)) ? parseInt(val, 10) : "";
  };

  var handleChange = function handleChange(key, changeValue) {
    if (changeValue === null || changeValue === "") {
      var valueObject = _objectSpread({}, value);

      delete valueObject[key];
      onChange(valueObject);
    } else {
      onChange(_objectSpread(_objectSpread({}, value), {}, _defineProperty({}, key, changeValue)));
    }
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "et--number-range ".concat(className ? className : "")
  }, /*#__PURE__*/React.createElement(NumericInput, {
    value: parseValidInt(value.gte),
    maskType: maskType,
    integerLimit: integerLimit,
    placeholder: minPlaceholder,
    disabled: disabled,
    className: "et--number-range--input",
    onChange: function onChange(value) {
      return handleChange("gte", value);
    },
    onKeyPress: onKeyPress,
    "aria-label": "Greater than or equal to"
  }), /*#__PURE__*/React.createElement("span", {
    className: "et--number-range---separator"
  }), /*#__PURE__*/React.createElement(NumericInput, {
    value: parseValidInt(value.lte),
    maskType: maskType,
    integerLimit: integerLimit,
    placeholder: maxPlaceholder,
    disabled: disabled,
    className: "et--number-range--input",
    onChange: function onChange(value) {
      return handleChange("lte", value);
    },
    onKeyPress: onKeyPress,
    "aria-label": "Less than or equal to"
  }));
};

Range.propTypes = {
  className: PropTypes.string,
  value: PropTypes.object,
  maskType: PropTypes.string,
  integerLimit: PropTypes.number,
  minPlaceholder: PropTypes.string,
  maxPlaceholder: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  onKeyPress: PropTypes.func
};
export default Range;